import { defineWidget } from '../../client/lib/contract/helpers'
import { t } from '../../client/i18n'
import { usageRender } from '../../client/families/usage/renders'

/** OpenCode Go monthly usage quota (single-window percent card). */
export default defineWidget({
  id: 'usage-monthly',
  name: () => t('widget.usage-monthly.name'),
  desc: () => t('widget.usage-monthly.desc'),
  builtin: false,
  group: 'opencode-go',
  render: usageRender('monthly', 'widget.usage-monthly.name'),
})